import { useEffect } from 'react';

/**
 * useWebSocket - Stub Hook for migration
 * 
 * Reemplazado temporalmente durante la migración a Firebase.
 * TODO: Implementar escuchas de Firestore (onSnapshot) aquí.
 */
export const useWebSocket = (eventId, callbacks = {}) => {
    useEffect(() => {
        // Placeholder for future Firestore listener implementation
    }, []);

    return {
        socket: null,
        emit: (event, data) => console.log("Mock Emit:", event, data),
        isConnected: true, // Fake it for UI
    };
};

/**
 * useEventRealtime - Stub Hook
 */
export const useEventRealtime = (eventId) => {
    return useWebSocket(eventId);
};

export default useWebSocket;
